<div class="pt-3 pb-5" >
  <div class="d-flex mt-3" >
  </div>
  <router-outlet></router-outlet>
  <!-- <footer></footer> -->
</div>
<loader></loader>